import axios from "axios";
import API from "../helpers/api";
let searchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 25,
};
let user = JSON.parse(localStorage.getItem("currentUser"));

export const getClientManagementList = (item) => {
  let url = `${API.GetShippingCompanies}?CompanyName=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClientListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getClientManagementDetails = (id) => {
  let url = `${API.GetShippingCompany}?ShippingcompanyId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        
        dispatch({
          type: "getClientDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
export const putClientManagementDetails = (data) => {
  let url = `${API.PutShippingCompany}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch(getClientManagementList(searchData));
        dispatch({
          type: "putClientDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putClientDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
export const postClientManagementDetails = (data) => {
  let url = `${API.PostShippingCompany}`;
  return (dispatch) => {
    axios
      .post(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch(getClientManagementList(searchData));
        dispatch({
          type: "postClientDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postClientDetailsFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClientUserDetails = (id) => {
  let url = `${API.getClientUsers}?clientId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let fleet =
          response.data &&
          response.data.filter((r) => r.userRole === "fleetmanager");
        let superintendent =
          response.data &&
          response.data.filter((r) => r.userRole === "superintendent");
        let executive =
          response.data &&
          response.data.filter((r) => r.userRole === "technicalexecutive");
          
        dispatch({ type: "GetFleetManagerlist", data: fleet });
        dispatch({ type: "GetTechSuperintendentlist", data: superintendent });
        dispatch({ type: "GetTechExecutivelist", data: executive });
        dispatch({ type: "ClientUserDetails", data: response.data });
        dispatch({
          type: "getClientUsersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientUsersListFailure",
          error: "ERROR",
        });
      });
  };
};

export const putClientUserDetails = (data) => {
  let url = `${API.postClientuser}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch({
          type: "putClientUserDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putClientUserDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const postClientUserDetails = (data) => {
  let url = `${API.postClient}`;
  return (dispatch) => {
    axios
      .post(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch({
          type: "postClientUserDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postClientUserDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
// export const putClientUserDetails = (data) => {
//     let url = `${API.ClientUser}`;
//     let searchData = {
//         Name: '',
//         PageNumber: 1,
//         PageSize: 25
//     };
//     return dispatch => {
//         axios.put(url, data)
//             .then((response) => {
//                 dispatch(getClientManagementList(searchData));
//                 dispatch({
//                     type: "postClientUserDetailsSuccess",
//                     data: response.data,
//                 })
//             })
//             .catch((error) => {
//                 dispatch({
//                     type: "postClientUserDetailsFailure",
//                     error: "ERROR"
//                 })
//             })
//     }
// }
// export const getClientUserList = (id) => {
//     let url = `${API.ClientUser}?clientId=${id}`;
//     return dispatch => {
//         axios.get(url)
//             .then((response) => {
//                 dispatch({ type: "ClientUserDetails", data: response.data });
//                 dispatch({
//                     type: "getClientUsersListSuccess",
//                     data: response.data,
//                 })
//             })
//             .catch((error) => {
//                 dispatch({
//                     type: "getClientUsersListFailure",
//                     error: "ERROR"
//                 })
//             })
//     }
// }
